import { List, IconTick, Text } from 'braid-design-system';

export const FreemiumFeatures = () => (
  <List type="icon" icon={<IconTick tone="formAccent" />}>
    {[
      'List for 6 months',
      "Appear on Australia's #1 business marketplace",
      'Receive emails from interested buyers',
    ].map((feature, i) => (
      <Text key={i}>{feature}</Text>
    ))}
  </List>
);
